import { useGetRelatedProductsQuery, useGetSimilarProductsQuery } from '@/screens/Product/api/productApiSlice'
import { useProduct } from '@/screens/Product/hooks/useProduct'

import { RecommendedProducts } from '@/features/recommended-products'

import { OrderType } from '@/shared/types/product-types'

type ProductRecommendationsBlockProps = {
	activeTab: string
	showAllAccessories: boolean
	onShowAllAccessories: () => void
}

export const ProductRecommendationsBlock = ({
	activeTab,
	showAllAccessories,
	onShowAllAccessories
}: ProductRecommendationsBlockProps) => {
	const { product } = useProduct()

	const shouldHideRelatedProducts = product.ORDER_TYPE === OrderType.HideBuy || product.ORDER_TYPE === OrderType.Archive
	const isRecommendationsTabVisible = activeTab === `description` || activeTab === `specs`
	const { data: relatedProducts, isLoading: isRelatedProductsLoading } = useGetRelatedProductsQuery(product.ID, {
		skip: shouldHideRelatedProducts || !isRecommendationsTabVisible || !product.ID
	})
	const { data: similarProducts, isLoading: isSimilarProductsLoading } = useGetSimilarProductsQuery(product.ID, {
		skip: !isRecommendationsTabVisible || !product.ID
	})

	if (!isRecommendationsTabVisible) return null

	return (
		<>
			{!shouldHideRelatedProducts && (
				<RecommendedProducts
					title="С этим товаром покупают"
					products={relatedProducts?.data?.PRODUCTS ?? []}
					isLoading={isRelatedProductsLoading}
					variant="subsection"
					action={showAllAccessories ? { text: 'Все товары', onClick: onShowAllAccessories } : undefined}
				/>
			)}
			<RecommendedProducts
				title="Похожие товары"
				products={similarProducts?.data?.PRODUCTS ?? []}
				isLoading={isSimilarProductsLoading}
				variant="subsection"
			/>
		</>
	)
}
